import { createContext, useState, useEffect } from "react";
import axios from "axios";
import config from '../constants/config';
import { clearDriverRideData, clearPassengerRideData } from "../utils/localStorage";

const API_URL = config.apiBaseUrl + "/user"; // Adjust your backend URL

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    if (storedUser) {
      setUser(storedUser);
    }

    setLoading(false);
  }, []);

  const login = async (MobileNo, Password, role, CompCd) => {
    // Call your API here
    const response = await axios.post(`${API_URL}/login`, { MobileNo, Password, role, CompCd });

    const data = await response.data.data;
    if (data.authToken) {
      setUser(data);
      // localStorage.setItem("user", JSON.stringify(data));
    }
    return data;
  };

  const signupUser = async (params) => {
    const response = await axios.post(`${API_URL}/signup`, params);

    const data = await response.data.data;
    if (data.authToken) {
      setUser(data);
      // localStorage.setItem("user", JSON.stringify(data));
    }

    return data;
  }

  const logout = () => {
    setUser(null);
    localStorage.removeItem("user");
    clearDriverRideData()
    clearPassengerRideData()

    // setTimeout(() => {
    // }, 1000)
  };

  return (
    <AuthContext.Provider value={{ user, login, signupUser, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};
